import React from 'react';
import { Router, Switch, Route as RouteDom } from 'react-router-dom';
import Home from 'pages/site/home/home.component';
import Landing from 'pages/site/landing/landing.component';
import SubpoenaPage from 'pages/site/subpoena-page/subpoena.component';
import Logout from 'pages/logout';
import EditUser from 'pages/site/user/edit/edit.user.component';
import ArticleDetails from 'pages/site/article/article.details.component';
import RouteAdminMapper from './routesAdmin';
import { RouteManager as Route } from 'component/_structure/routeManager';
import Mission from 'pages/site/mission/mission.component';
import Contact from 'pages/site/contact/contact.component';
import Termos from 'pages/site/politics/termsUsage.component';
import PoliticaCookies from 'pages/site/politics/cookies.component';
import Clipping from 'pages/site/clipping/clipping.component';
import ResumeClipping from 'pages/site/clipping/resume/clipping.resume.admin.component';
import history from 'config/history';
import AboutClipping from 'pages/site/calendar-auth';
import UserRecords from 'pages/site/records/index';
import Auth from 'pages/site/user/auth/';
import ArticleList from 'pages/site/home/article/article.list.component';

export default function RouteMapper() {
  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/" component={Landing} />
        <RouteDom exact path="/landing" component={Home} />
        <Route exact path="/intimacoes-aasp" component={SubpoenaPage} />
        <Route exact path="/logout" component={Logout} />
        <Route exact path="/acesso" component={Auth} />
        <Route exact path="/perfil" component={EditUser} />
        <Route exact path="/artigos/:slug" component={ArticleDetails} />
        <Route exact path="/proposito" component={Mission} />
        <Route exact path="/termos-de-uso" component={Termos} />
        <Route exact path="/politica-de-cookies" component={PoliticaCookies} />
        <Route exact path="/contato" component={Contact} />
        <Route exact path="/acompanhar-agenda" component={ResumeClipping} />
        <Route exact path="/novo-recorte" component={Clipping} />
        <Route exact path="/sobre-recorte" component={AboutClipping} />
        <Route exact path="/evento/editar" component={Clipping} />
        <Route exact path="/template/:id" component={UserRecords} />
        <Route exact path="/artigos" component={ArticleList} />
        <RouteAdminMapper />
      </Switch>
    </Router>
  );
}
